<div class="mat-headline-4">{{ 'SETTINGS.PASSWORD.TITLE' | translate }}</div>

@if (hasExternalIdp) {
    <div
        class="tw-mt-10"
        [innerHTML]="'SETTINGS.EXTERNAL-IDP-INFO' | translate"></div>
} @else {
    <div class="tw-w-3/6 tw-mt-10 tw-flex tw-flex-col">
        <span>{{ 'SETTINGS.PASSWORD.INFO' | translate }}</span>
        <button
            class="tw-mt-3 !tw-flex !tw-items-center"
            mat-raised-button
            (click)="requestPasswordChange()"
            color="primary"
            [disabled]="isLoading() || !canModifyProfile">
            @if (!isLoading()) {
                <mat-icon
                    class="tw-mr-2"
                    fontSet="material-symbols-outlined">
                    exit_to_app
                </mat-icon>
            }
            @if (isLoading()) {
                <mat-progress-spinner aria-label="Wird geladen"
                    diameter="14"
                    mode="indeterminate"
                    color="accent"
                    class="tw-mr-2">
                </mat-progress-spinner>
            }
            {{ 'SETTINGS.PASSWORD.TITLE' | translate }}
        </button>
    </div>
}
